import React, {  useState } from 'react';
import TermsofUseDialog from './TermsofUseDialog';
const CreateAccountFooter = () => {
  const [termsofUse, setTermsofUse] = useState(false);
  return (
    <div
    style={{
      position: 'fixed',  // Change position to fixed
      bottom: '0',       // Stick it to the bottom
      width: '100%',      // Full width
      backgroundColor: '#FFF', // Add a background color if needed
      borderTop: '1px solid #ccc', // Add a border if needed
      padding: '10px 20px', // Adjust padding as per your preference
    
    }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          // justifyContent: 'space-between',
          marginLeft: '20px',
        }}
      >
        <div
          style={{
            color: '#646B77',
            fontSize: '12px',
            fontWeight: '500',
            cursor: 'pointer',
          }}
        >
          Datascient.ai V 1.1
        </div>
        <div
          style={{
            display: 'flex',
            width: '20%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginRight: '20px',
            marginLeft:'45%'
          }}
        >
          <div
            style={{
              color: '#646B77',
              fontSize: '12px',
              fontWeight: '500',
              cursor: 'pointer',
            }}
            onClick={() => {
              setTermsofUse(!termsofUse);
            }}
          >
            Privacy Policy
          </div>
          <div
            style={{
              color: '#646B77',
              fontSize: '12px',
              fontWeight: '500',
              cursor: 'pointer',
            }}
            onClick={() => {
              setTermsofUse(!termsofUse);
            }}
          >
            Terms of Use
          </div>
        </div>
      </div>
      <TermsofUseDialog open={termsofUse} handleClose={()=>{setTermsofUse(!termsofUse)}}/>

    </div>
  );
};

export default CreateAccountFooter;
